<template>
  <div class="mt-3 ml-3">
    <CtaButton text="Example" />
  </div>
</template>

<script>
import CtaButton from '@/components/buttons/CtaButton.vue';

export default {
  components: {
    CtaButton,
  },
};
</script>
